import type { AnalyticsEventMetadata } from "lib/analytics";
import { sendAnalyticsEvent } from "lib/analytics";
import { useUserContext } from "lib/state/UserContextProvider";
import { usePlanLibrarySelector } from "./planLibraryStore";
import type { PlanLibraryEvent } from "./planLibraryTypes";

const ANALYTICS_PRODUCT_NAME = "config";

export default function usePlanLibraryEvents() {
  const { builder } = useUserContext();
  const { planName, planType, planId } = usePlanLibrarySelector((state) => ({
    planName: state.planName,
    planType: state.plans.planType,
    planId: state.planId,
  }));

  return (eventName: PlanLibraryEvent, metadata: AnalyticsEventMetadata = {}) => {
    sendAnalyticsEvent(eventName, {
      builder_id: builder?.id,
      builder_name: builder?.companyName,
      product: ANALYTICS_PRODUCT_NAME,
      plan_name: planName,
      plan_type: planType,
      plan_id: planId,
      ...metadata,
    });
  };
}
